export default __webpack_public_path__ + "static/media/avatar-discounts_club_bot.db517eea.png";